module.exports = __webpack_public_path__ + "static/media/ehealth_pro_info_share_p2_1.f9e3baf4.png";